export default "__VITE_ASSET__B8u1P3Ou__"